import { Link } from 'react-router-dom'
import Protected from '../Protected'


const modules = [  
  {
    permission: 'createAccount',
    module_name: 'Application resources',
    icon: 'bi bi-person-check',
    to: '/appresources'
  },
  {
    permission: 'createActors',
    module_name: 'Actors',
    icon: 'bi bi-mic',
    to: '/prodresources'
  },
  {
    permission: 'createTeams',
    module_name: 'Resource Teams',
    icon: 'bi bi-people',
    to: '/teams'
  },
  {
    permission: 'manageRecBooths',
    module_name: 'Recording Rooms',
    icon: 'bi bi-box',
    to: '/recbooths'
  },
  /*{
    permission: 'setPronunciationGlossaries',
    module_name: 'Pronunciations',
    icon: 'bi bi-globe',
    to: '/pronglossaries'
  },*/
  {
    permission: 'manageSites',
    module_name: 'Sites',
    icon: 'bi bi-pin-map',
    to: '/sites'
  },
  {
    permission: 'manageClients',
    module_name: 'Clients',
    icon: 'bi bi-joystick',
    to: '/clients'
  },
  {
    permission: 'manageLanguages',
    module_name: 'Languages',
    icon: 'bi bi-translate',
    to: '/languages'
  },
  {
    permission: 'manageFranchise',
    module_name: 'Franchises',
    icon: 'bi bi-signpost-split',
    to: '/franchises'
  },
  {
    permission: 'UITemp',
    module_name: 'Roles',
    icon: 'ri-user-settings-line',
    to: '/roles'
  },
  {
    permission: 'UITemp',
    module_name: 'Roles Permission',
    icon: 'ri-git-repository-private-line',
    to: '/rolePermissions'
  },
  {
    permission: 'UITemp',
    module_name: 'S3 Manager',
    icon: 'ri-git-repository-private-line',
    to: '/s3manager'
  },
  {
    permission: 'UITemp',
    module_name: 'Logs',
    icon: 'ri-git-repository-private-line',
    to: '/logs'
  },
  {
    permission: 'bankHolidays',
    module_name: 'Bank holidays',
    icon: 'ri-sun-line',
    to: '/bankHolidays'
  },
  {
    permission: 'UITemp',
    module_name: 'EC2',
    icon: 'ri-sun-line',
    to: '/ec2Win'
  },
  {
    permission: 'UITemp',
    module_name: "What's New",
    icon: 'bi bi-megaphone',
    to: '/whatsNew'
  },
  {
    permission: 'UITemp',
    module_name: 'Task Types',
    icon: 'bi bi-tags',
    to: '/tasktypes'
  },
]

/* array for active in Left Menu */
export const adminLinks = () => {
  return modules.map(el => el.to) 
}

export const BreadcrumbAdmin = () => {
  return <li className="breadcrumb-item">
          <Link to={"/admin"}>Admin Panel</Link>
        </li>
}
 

export const ProjectSupportComponents = (props) => {

  return (
    <>
      <ul className="nav nav-tabs" id="borderedTab">
        {modules.map((m, idx) => {
          return (
            <Protected key={idx} returnNull={true} permissions={[m.permission]} >
              <Link className="nav-item" role="presentation" to={m.to}>
                <button className={"projectNav nav-link"  + (props.data === idx ? ' active' : '')} id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-home" type="button" role="tab" aria-controls="home" aria-selected="true"><i className={m.icon}></i> {m.module_name}</button>
              </Link>
            </Protected>
          )
        })}

      </ul>
    </>
  )
}

export const AdminHomePage = (props) => {

  return (
    <main id="main" className="main">
      <div key="title" className="pagetitle">
          <h1>Admin Panel</h1>
          <nav>
              <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                      <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Admin Panel</li>
              </ol>
          </nav>
      </div>

      <div key="card" className="card">
        <div className="card-body mt-3">
          <div className="row">
            {modules.map((m, idx) => {
              return (
                <Protected key={idx} returnNull={true} permissions={[m.permission]}>
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3" >
                    <Link  className="card" to={m.to}> 
                      <div className="card-body text-center" style={{maxHeight: 140}}>  
                        <p className="card-text">
                        <i style={{position: 'relative', fontSize: '40px', top: 13}} className={m.icon}></i>
                        </p>
                        <h5 className="card-title" style={{margin: 0}}>{m.module_name}</h5>
                      </div>
                    </Link>
                  </div>
                </Protected>
              )
            })}
          </div>
        </div>
      </div>
    </main>
  )
}
